import { useInView as useOriginalInView } from 'react-intersection-observer';

const isIntersectionObserverSupported =
  typeof window !== 'undefined' &&
  'IntersectionObserver' in window &&
  'IntersectionObserverEntry' in window &&
  'intersectionRatio' in window.IntersectionObserverEntry.prototype;

export const useInView = options => {
  if (!isIntersectionObserverSupported) {
    return [null, true];
  }

  return useOriginalInView(options);
};
